/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Lastactive1Inputs */

const en_common_lastactive1 = /** @type {(inputs: Common_Lastactive1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last active`)
};

/**
* | output |
* | --- |
* | "Last active" |
*
* @param {Common_Lastactive1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_lastactive1 = /** @type {((inputs?: Common_Lastactive1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Lastactive1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_lastactive1(inputs)
});
export { common_lastactive1 as "common_lastActive" }